<div class="container-fluid common-pages-banner">
    <div class="container">
        <div class="tg-theme-heading">
            <h1 class="h1tags">Contact Propira</h1>
        </div>
    </div>
</div>


<div class="col-md-12 breaeea">

    <ul class="breadcrumb">
        <li><a routerLink="/">Home</a></li>
        <li>Contact Us</li>
    </ul>

</div>

<div class="container-fluid paddEqual bgGray">
    <div class="container">
        <div class="row">
            <div class="col-md-3 col-12 mp0" style="display: none">
                <div class="row rowLeftM">
                    <div class="col-12 pd-0 usersformms">
                        <div class="row marginZero common-leftbar">
                            <div class="col-12">
                                <div class="col-12 usersHeader">
                                    <h4 class="card-title">Email Us At:</h4>
                                </div>
                                <p>Sales/General Enquires:</p>
                                <a href="mailto:sales@propira.com">sales@propira.com</a>
                                <div class="col-12 usersHeader">
                                    <h4 class="card-title">Call Us At:</h4>
                                </div>
                                <p>Sales/General Enquires:</p>
                                <a href="tel:+919870260930">+91 9870 260 930</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-12">
                <div class="row rowLeftM justify-content-center">
                    <div class="col-md-8 col-xl-8 col-12 pd-0 usersformms">
                        <div class="row marginZero contact-img-query">
                            <h1>Please Reach out to <u> <a href="mailto:Support@propira.com ">Support@propira.com</a></u>
                                for any
                                queries! </h1>
                            <div class="img-contact-box">
                                <img src="assets/images/contact_us.gif" alt="contact-us" class="img-fluid">
                            </div>
                            <!-- <div class="col-12">
                                <div class="col-12 usersHeader">
                                    <h4 class="card-title">Contact Us</h4>
                                </div>
                                <form class="col-12 pd-0" [formGroup]="contact" [ngClass]="{'white-layer':contactLoader}" (ngSubmit)="contactEnd()" style="position: relative;">
                                    <div class="alert alert-danger alert-dismissible fade show" *ngIf="contactErrorMsg">
                                        <strong>Error!</strong> {{contactErrorMsg}}.
                                        <button type="button" style="background: none;" class="close" data-dismiss="alert">&times;</button>
                                    </div>
                                    <div class="alert alert-success alert-dismissible fade show" *ngIf="contactSuccessMsg">
                                        <strong>Success!</strong> {{contactSuccessMsg}}.
                                        <button type="button" style="background: none;" class="close" data-dismiss="alert">&times;</button>
                                    </div>
                                    <div class="form-group">
                                        <label>Name</label>
                                        <input type="text" class="form-control" required formControlName="name" placeholder="Enter Name" (keypress)="validateAlpha($event)">
                                        <div class="error-msg" *ngIf="contactControl.name.touched && contactControl.name.errors">
                                            <div style="font-size: 12px">Enter name</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Email-Id</label>
                                        <input type="email" class="form-control" required formControlName="email" placeholder="Enter Email Id">
                                        <div class="error-msg" *ngIf="contactControl.email.touched && contactControl.email.errors">
                                            <div style="font-size: 12px">Enter valid email id</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Phone Number</label>
                                        <input type="tel" class="form-control" required formControlName="phone" placeholder="Enter Phone Number" (keypress)="numberOnly($event,10)">
                                        <div class="error-msg" *ngIf="contactControl.phone.touched && contactControl.phone.errors">
                                            <div style="font-size: 12px">Enter valid phone number</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>State</label>
                                        <select class="form-control" formControlName="state_id" required (change)="getCityList($event.target.value)">
                                            <option value="">Please select state</option>
                                            <option *ngFor="let state of stateList" value="{{state.id}}">{{state.name | titlecase}}</option>
                                        </select>
                                        <div class="error-msg" *ngIf="contactControl.state_id.touched && contactControl.state_id.errors">
                                            <div style="font-size: 12px">Select state name</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>City</label>
                                        <select class="form-control" formControlName="city_id" required>
                                            <option value="">Please Select City</option> 
                                            <option *ngFor="let city of cityList" value="{{city.id}}">{{city.name | titlecase}}</option>
                                        </select>
                                        <div class="error-msg" *ngIf="contactControl.city_id.touched && contactControl.city_id.errors">
                                            <div style="font-size: 12px">Select city name</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Message</label>
                                        <textarea class="form-control" required formControlName="message" placeholder="Enter Message"></textarea>
                                        <div class="error-msg" *ngIf="contactControl.message.touched && contactControl.message.errors">
                                            <div style="font-size: 12px">Enter message</div>
                                        </div>
                                    </div>
                                  <input  class="form-control" type="checkbox" formControlName="terms"  id="terms" required style="margin-right: 10px;display: inline;height:14px;width: 2%;">I Agree Terms & Coditions
                                    <br><br>
                                    <div class="error-msg" *ngIf="contactControl.terms.touched && contactControl.terms.errors">
                                    <div style="font-size: 12px">Please check the box for further proceed </div>
                                    </div> 
                                    <div class="form-group">
                                        <button class="btn btn-danger" type="submit">Submit <div class="box" *ngIf="contactLoader"><div class="loader-13"></div>
                                        </div></button>
                                    </div>
                                </form> 
                          </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>